var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"translation-tab",class:{'is-selected': _vm.selected}},[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.button)?_c('LinkUnderline',[_vm._v(_vm._s(_vm.button))]):_vm._e(),(_vm.icon)?_c('SvgIcon',{attrs:{"name":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }